import React from 'react';
import MUIDataTable from 'mui-datatables';

// Material Resources
import { IconButton, Tooltip, Typography, TableCell } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

// GraphQl
import { useQuery, useMutation } from '@apollo/react-hooks';

// Components & Others
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import CustomOptions from '../../../CustomOptions';
import LoadingIndicator from '../../../LoadingIndicator';
import { LIST_DOCUMENT_TYPES, DELETE_DOCUMENT_TYPE } from '../queries';
import CustomColumnHeader from '../../../TableComponents/CustomColumnHeader';
import { edgeToList, getOptions } from '../../../../utils/commonFunctions';
import { textLabels } from '../../../../translations/components/MUIDataTable';

// Styles & Images
import useStyles from './styles';

function CustomToolbar() {
  const history = useHistory();

  const handleClick = () => {
    history.push('/administrador/tipos-de-documento/crear');
  };

  return (
    <Tooltip title="Nuevo tipo de documento">
      <IconButton color="secondary" onClick={handleClick}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}

function DocumentTypeList() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [deleteIntrument] = useMutation(
    DELETE_DOCUMENT_TYPE,
    getOptions({
      mutationName: 'deleteDocumentType',
      modelName: 'documentType',
      message: 'Tipo de documento eliminado con éxito.',
      enqueueSnackbar,
    })
  );
  const { loading, error, data } = useQuery(LIST_DOCUMENT_TYPES);

  if (error) {
    console.error(error);
  }

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        sort: true,
        customHeadRender: (columnMeta, updateDirection) => {
          return (
            <CustomColumnHeader
              id={0}
              key={0}
              columnMeta={columnMeta}
              updateDirection={updateDirection}
            />
          );
        },
      },
    },
  ];
  columns.push({
    name: 'id',
    label: 'Opciones',
    options: {
      sort: false,
      customBodyRender: value => {
        const id = value;
        return (
          <CustomOptions
            id={id}
            model="Tipo de documento"
            options={['oedit', 'odelete']}
            handleDelete={() => {
              deleteIntrument({ variables: { id } });
              data.listDocumentTypes.edges = data.listDocumentTypes.edges.filter(
                e => e.node.id !== id
              );
            }}
          />
        );
      },
      customHeadRender: columnMeta => {
        return (
          <TableCell key={1} style={{ borderBottom: 'none' }}>
            <Typography
              variant="subtitle1"
              align="left"
              className={classes.tableTitle}
            >
              {columnMeta.label}
            </Typography>
          </TableCell>
        );
      },
    },
  });

  const handleRowClick = (rowData, rowMeta) => {
    if (rowData[rowData.length - 1] && rowData[rowData.length - 1].props) {
      history.push(
        `/administrador/tipos-de-documento/${
          rowData[rowData.length - 1].props.id
        }`
      );
    }
  };

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    print: false,
    filter: false,
    download: false,
    textLabels,
    customToolbar: () => {
      return <CustomToolbar />;
    },
    onRowClick: rowData => {
      handleRowClick(rowData);
    },
  };

  return (
    <>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <MUIDataTable
          title="Tipos de documento"
          data={edgeToList(data, 'listDocumentTypes')}
          columns={columns}
          options={options}
        />
      )}
    </>
  );
}

export default DocumentTypeList;
